export const GET_SOURCE_LIST = 'GET_SOURCE_LIST';
export const SET_SOURCE_LIST = 'SET_SOURCE_LIST';
export const CREATE_SOURCE = 'CREATE_SOURCE';
export const CREATE_SOURCE_SUCCESS = 'CREATE_SOURCE_SUCCESS';
export const CREATE_SOURCE_FAILURE = 'CREATE_SOURCE_FAILURE';
export const CLEAR_SOURCE_ERROR = 'CLEAR_SOURCE_ERROR';
export const GET_SOURCE_DETAILS = 'GET_SOURCE_DETAILS';
export const SET_SOURCE_DETAILS = 'SET_SOURCE_DETAILS';
export const UPDATE_SOURCE_STATUS = 'UPDATE_SOURCE_STATUS';
export const UPDATE_SOURCE_STATUS_SUCCESS = 'UPDATE_SOURCE_STATUS_SUCCESS';
export const SET_STATUS_UPDATE_SUCCESS = 'SET_STATUS_UPDATE_SUCCESS';
